import React from 'react';
import VirtualTour from './components/VirtualTour';
import './styles/VirtualTour.css';

function App() {
    return (
        <div className="App">
            <VirtualTour />
        </div>
    );
}

export default App;
